// src/components/store/sections/testimonials/TestimonialV39QuoteminimalFuchsiaGlow.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV39QuoteminimalFuchsiaGlow(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={39}
      archKey="quote_minimal"
      archLabel="Editorial Quotes"
      palName="FuchsiaGlow"
      grad="from-fuchsia-500 via-pink-500 to-purple-700"
      lightBg="bg-fuchsia-50"
      textCol="text-fuchsia-700"
      borderCol="border-fuchsia-200"
      btnCls="bg-fuchsia-600 hover:bg-fuchsia-700"
      hexCol="#d946ef"
      {...props}
    />
  );
}
